import React from 'react';

import { PAGE_TITLE } from '../../constants';
import Component from '../../components/schools';
import Container from '../../containers/admin';
import Root from '../../components/root';

export default function PageDashboard() {
  return (
    <Root title={PAGE_TITLE.DASHBOARD}>
      <Container>
        <Component />
      </Container>
    </Root>
  );
};
